import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 15000,
});

export async function checkDomain(query) {
    const { data } = await api.post("/domain/check", { query });
    return data;
}

export async function subscribeNewsletter(email, locale = "en") {
    const { data } = await api.post("/newsletter", { email, locale });
    return data;
}

export async function submitContact(payload) {
    const { data } = await api.post("/contact", payload);
    return data;
}
